export default "public/PolicyConnect.png";